export default "__VITE_ASSET__fqgZzLQV__"